module.exports = __webpack_public_path__ + "static/media/events.069807b0.svg";